import {BodyRow, BodyRowMapper, HeaderCell, HeaderRow, Table} from "../../components/Table";
import {AdminServer, AdminUser, RconMode, rconModeLabel, subscriptionTierLabel} from "./interfaces";

export default function ServersTable(props: {
    servers?: AdminServer[]
    users?: AdminUser[]
    loading: boolean
}) {
    const usersById = new Map((props.users ?? []).map(u => [u.id, u]))

    return <Table defaultSortKey="displayName">
        <HeaderRow>
            <HeaderCell sortKey="id">ID</HeaderCell>
            <HeaderCell sortKey="displayName">Name</HeaderCell>
            <HeaderCell sortKey="owner">Owner</HeaderCell>
            <HeaderCell sortKey="tier">Tier</HeaderCell>
            <HeaderCell sortKey="mode">RCON mode</HeaderCell>
            <HeaderCell sortKey="isDisabled">Status</HeaderCell>
            <HeaderCell sortKey="playerCount">Players</HeaderCell>
            <HeaderCell sortKey="consoleMessageCount">Console msgs</HeaderCell>
            <HeaderCell>Moderators</HeaderCell>
        </HeaderRow>
        <BodyRowMapper data={props.servers} placeholder={props.loading ? "Loading servers..." : "No servers"}
                       map={(server: AdminServer) =>
                           <BodyRow key={server.id}>
                               <td className="font-mono text-xs text-neutral-400 select-text cursor-text">{server.id}</td>
                               <td className="font-medium">{server.displayName}</td>
                               <td className="text-neutral-300">
                                   <UserLabel userId={server.owner} usersById={usersById}/>
                               </td>
                               <td>{subscriptionTierLabel(server.tier)}</td>
                               <td>{rconModeLabel(server.mode)}</td>
                               <td>
                                   {/* Plugin RCON servers connect via reverse WS, so a disabled one still counts as active. */}
                                   {(!server.isDisabled || server.mode === RconMode.PluginRcon)
                                       ? <span className="text-green-400">Active</span>
                                       : <span className="text-neutral-400">Disabled</span>}
                               </td>
                               <td className="text-neutral-300">{server.playerCount}</td>
                               <td className="text-neutral-300">{server.consoleMessageCount}</td>
                               <td className="text-neutral-300">
                                   {server.users.length === 0
                                       ? "-"
                                       : <div className="flex flex-col gap-0.5 max-h-32 overflow-auto">
                                           {server.users.map(id =>
                                               <UserLabel key={id} userId={id} usersById={usersById}/>)}
                                       </div>}
                               </td>
                           </BodyRow>
                       }/>
    </Table>
}

function UserLabel(props: { userId: string, usersById: Map<string, AdminUser> }) {
    const user = props.usersById.get(props.userId)
    if (!user) {
        return <span className="font-mono text-xs text-neutral-400 select-text cursor-text">{props.userId}</span>
    }
    return <span>
        {user.name}
        {" "}
        <span className="text-neutral-400 select-text cursor-text">({user.email})</span>
    </span>
}
